import { render, staticRenderFns } from "./Peoples.vue?vue&type=template&id=480a8abe&"
import script from "./Peoples.vue?vue&type=script&lang=js&"
export * from "./Peoples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports